import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { ILineItem } from 'src/common/interfaces/dtos/ILineItem';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { ReactComponent as TareLink } from 'src/common/media/link.svg';
import ReturnItemIcon from 'src/common/media/return-item-icon.svg';
import { styles } from '../top-customer-advert-styles';

interface Props {
  item: IElectronicJournalRecord;
}

const TopReturnItemDetails: React.FC<Props> = ({ item }): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  const linkedLineList = item.LinkedLines?.map((linkedItem: ILineItem) => {
    const linkedLineText = linkedItem.Description;
    const linkedLinePrice =
      linkedItem.Amount && linkedItem.Amount > 0 ? `-$${linkedItem.Amount}` : '';
    return (
      <Grid
        className={`${classes.returnRow} ${classes.returnlinkedItemRow}`}
        key={`${item.ItemId}-${linkedItem.SequenceNumber}`}
      >
        <Grid className={classes.iconSpacing} data-testid={'customer-link-item-indicator'}>
          <TareLink className={classes.promotion} />
        </Grid>
        <Grid
          data-testid={`customer-link-item-name`}
          className={`${classes.returnShadowText} ${classes.alignLeft}`}
        >
          {`${linkedLineText}`}
        </Grid>
        <Grid
          data-testid={`customer-link-item-price`}
          className={`${classes.returnShadowText} ${classes.alignRight}`}
        >
          {linkedLinePrice}
        </Grid>
      </Grid>
    );
  });
  return (
    <Grid container className={classes.returnContainer}>
      <Grid className={classes.returnRow}>
        <Grid className={classes.iconSpacing}>
          <img
            src={ReturnItemIcon}
            alt=''
            data-testid='top-customer-advert-returnItemIcon'
            className={classes.returnIcon}
          />
        </Grid>
        <Grid
          data-testid='top-customer-advert-returnText'
          className={`${classes.returnText} ${classes.alignLeft} ${classes.topReturnFlexBox}`}
        >
          {t('ItemReturn')}
        </Grid>
        <Grid
          data-testid='top-customer-advert-returnItemPrice'
          className={`${classes.returnText} ${classes.alignRight}`}
        >
          {`-${convertCurrency(item.RawPrice || 0)}`}
        </Grid>
      </Grid>
      <Grid className={classes.returnRow}>
        <Grid className={classes.iconSpacing}></Grid>
        <Grid
          data-testid='top-customer-advert-returnItem'
          className={`${classes.returnShadowText} ${classes.alignLeft} ${classes.topReturnFlexBox}`}
        >
          {item.Description}
        </Grid>
        <Grid className={`${classes.returnShadowText} ${classes.alignRight}`}>
          {`-${convertCurrency(Number(item.ExtendedAmount) || 0)}`}
        </Grid>
      </Grid>
      {linkedLineList}
    </Grid>
  );
};

export default TopReturnItemDetails;
